// Suporte central da Laudando Online.
// Telefone único de suporte (WhatsApp). Formato E.164 sem sinais: 55 + DDD + número.
export const SUPPORT_PHONE_E164 = '5531997018872';
export const SUPPORT_PHONE_DISPLAY = '(31) 99701-8872';
export const SUPPORT_EMAIL = 'contato@laudando.online';

export const whatsappUrl = (message = '') =>
  `https://wa.me/${SUPPORT_PHONE_E164}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

export const SUPPORT_MESSAGES = {
  general: 'Olá! Vim pelo site da Laudando Online e gostaria de tirar uma dúvida.',
  sales: 'Olá! Tenho interesse nos planos da Laudando Online e gostaria de mais informações.',
  enterprise:
    'Olá! Trabalho com uma equipe/volume maior de laudos e gostaria de conhecer um plano sob demanda da Laudando Online.',
  support: 'Olá! Preciso de ajuda com a minha conta na Laudando Online.',
  billing: 'Olá! Tenho uma dúvida sobre a assinatura/pagamento da minha conta na Laudando Online.',
};

export const firstNameFromUser = (user) => {
  const name = String(user?.name || '').trim();
  if (name) return name.split(/\s+/)[0];
  const email = String(user?.email || '').trim();
  return email ? email.split('@')[0] : 'usuário';
};

export const waUserSupport = (user) => {
  const firstName = firstNameFromUser(user);
  const email = String(user?.email || '').trim() || 'não informado';
  return whatsappUrl(`Ei, ${firstName}! Estou usando o Laudando e preciso de ajuda. Meu email da plataforma é ${email} e me chamo ${firstName}.`);
};

export const waGeneral = () => whatsappUrl(SUPPORT_MESSAGES.general);
export const waSales = () => whatsappUrl(SUPPORT_MESSAGES.sales);
export const waEnterprise = () => whatsappUrl(SUPPORT_MESSAGES.enterprise);
export const waSupport = () => whatsappUrl(SUPPORT_MESSAGES.support);
export const waBilling = () => whatsappUrl(SUPPORT_MESSAGES.billing);
